import { axiosInstance } from "@/lib/axiosInstance";

export type DegreeType = "ug" | "pg" | "phd" | "diploma" | "certificate" | string;
export type EducationStatus = "active" | "completed" | "on_hold" | "dropped" | string;

export interface EducationType {
  id: string;
  student_id: string;
  college_id: string;
  college_name: string;
  degree_type: DegreeType;
  degree_name: string;
  roll_number: string;
  start_year: number;
  end_year: number;
  status: EducationStatus;
  is_alumni: boolean;
  created_at: string;
  updated_at: string;
}

export interface EducationPayloadType {
  college_id?: string;
  college_name: string;
  degree_type?: DegreeType;
  degree_name: string;
  roll_number: string;
  start_year: number;
  end_year: number;
  status: EducationStatus;
}

export const fetchEducationList = async (): Promise<EducationType[]> => {
  const res = await axiosInstance.get("/v1/education");
  return res.data?.data && Array.isArray(res.data.data) ? res.data.data : res.data;
};

export const addEducation = async (data: EducationPayloadType): Promise<EducationType> => {
  const res = await axiosInstance.post("/v1/education", data);
  return res.data?.data || res.data;
};

export const getEducation = async (id: string): Promise<EducationType> => {
  const res = await axiosInstance.get(`/v1/education/${id}`);
  return res.data?.data || res.data;
};

export const updateEducation = async (id: string, data: Partial<EducationPayloadType>): Promise<EducationType> => {
  const res = await axiosInstance.patch(`/v1/education/${id}`, data);
  return res.data?.data || res.data;
};

export const deleteEducation = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/v1/education/${id}`);
};

export const fetchAlumniList = async (college_id: string): Promise<EducationType[]> => {
  const res = await axiosInstance.get(`/v1/education/internal/alumni/${college_id}`);
  return res.data?.data && Array.isArray(res.data.data) ? res.data.data : res.data;
};
